<template lang="html">
  <div class="admin-portal-analytics-container">
    <div class="row col-xs no-margin no-padding">
      <adminViewAnalyticsFiltersBar @date_filter="searchAnalytics" />
    </div>
    <div class="row mt4">
      <div class="col-xs-12">
        <adminViewAnalyticsGeneralInfo
          :numberOfTeachersThatCreatedAtLeastOneRt="
            number_of_teachers_that_created_at_least_one_rt
          "
          :numberActiveStudents="number_active_students"
          :numberOfTeachersThatRanAtLeastOneRt="
            number_of_teachers_that_ran_at_least_one_rt
          "
          :numberActivitiesCreated="number_of_activities_created"
          :numberActivitiesRun="number_of_activities_run"
          :numberOfLiveDiscussionsCreated="number_of_lds_created"
          :numberOfLiveDiscussionsRun="number_of_lds_run"
          :numberOfRtsCreatedFromUniverse="number_of_rts_created_from_universe"
          @showRoundtablesInfo="showRoundtablesModal"
        />
      </div>
    </div>
    <pl-dialog
      v-if="show_roundtables_list"
      :title="header_modal"
      @close="closeModal"
      :size="'md'"
    >
      <body class="px-7 pt-7 pb-4 mb-3 flex-grow overflow-y-auto">
        <table class="mt-3 w-100">
          <thead class="flex font-bold">
            <td class="col-xs-4">Title</td>
            <td class="col-xs-2">Students Invited</td>
            <td class="col-xs-3">Teacher</td>
            <td class="col-xs-3">Course / Section</td>
          </thead>
          <div
            class="mx-3"
            id="admin-view-roundtables-table"
            @scroll="handleScroll(page_number)"
          >
            <tr
              class="row middle-xs row-style"
              v-for="(rt, index) in roundtables_to_show"
              :key="index"
            >
              <td
                class="col-xs-4 truncate-text"
                :class="rt.course_school_id ? 'linkable text-primary' : ''"
                @click="goToRoundtable(header_modal, rt)"
              >
                {{ rt.title }}
              </td>
              <td class="col-xs-2 truncate-text p4">
                {{ rt.invited_users }}
              </td>
              <td class="col-xs-3 truncate-text">
                {{ rt.teacher }}
              </td>
              <td
                class="col-xs-3 truncate-text"
                :class="rt.course_school_id ? 'linkable text-primary' : ''"
                @click="goToCourse(rt)"
              >
                {{ rt.course_title }}
              </td>
            </tr>
          </div>
        </table>
      </body>
    </pl-dialog>
  </div>
</template>
<script>
  import adminViewAnalyticsFiltersBar from './adminViewAnalyticsFiltersBar.vue';
  import adminViewAnalyticsGeneralInfo from './adminViewAnalyticsGeneralInfo.vue';
  import adminServices from 'services/admin/adminServices';
  import URLconfigs from 'services/apiConfigs';
  import courseDetailsService from 'services/courses';
  import { EventBus } from 'utils/event-bus';

  export default {
    components: {
      adminViewAnalyticsFiltersBar,
      adminViewAnalyticsGeneralInfo,
    },
    data() {
      return {
        number_of_teachers_that_created_at_least_one_rt: 0,
        number_of_teachers_that_ran_at_least_one_rt: 0,
        number_of_activities_created: 0,
        number_of_activities_run: 0,
        number_of_lds_created: 0,
        number_of_lds_run: 0,
        number_active_students: 0,
        number_of_rts_created_from_universe: 0,
        roundtables_to_show: [],
        filter_values: '',
        header_modal: '',
        show_roundtables_list: false,
        page_size: 100,
        page_number: 1,
        show_more_roundtables: true,
        list_roundtable_type: '',
      };
    },
    computed: {},
    methods: {
      getNumberOfTeachersThatCreatedAtLeastOneCreated(values) {
        adminServices
          .getSystemWideData(
            values,
            'daily_number_of_teachers_that_created_at_least_one_roundtable'
          )
          .then(
            (res) =>
              (this.number_of_teachers_that_created_at_least_one_rt = Number(
                res.data
              ))
          );
      },
      getNumberActiveStudents: async function (values) {
        const { data } = await adminServices.getSystemWideData(
          values,
          'daily_number_active_students'
        );
        this.number_active_students = Number(data);
      },
      getNumberOfTeachersThatRanAtLeastOneCreated(values) {
        adminServices
          .getSystemWideData(
            values,
            'daily_number_of_teachers_that_ran_at_least_one_roundtable'
          )
          .then(
            (res) =>
              (this.number_of_teachers_that_ran_at_least_one_rt = Number(
                res.data
              ))
          );
      },
      getNumberOfRoundtablesCreated(values) {
        adminServices
          .getSystemWideData(values, 'daily_number_of_roundtables_created')
          .then(
            (res) => (this.number_of_activities_created = Number(res.data))
          );
      },
      getNumberOfRoundtablesRun(values) {
        adminServices
          .getSystemWideData(values, 'daily_number_of_roundtables_run')
          .then((res) => (this.number_of_activities_run = Number(res.data)));
      },
      getNumberOfLiveDiscussionsCreated(values) {
        adminServices
          .getSystemWideData(values, 'daily_number_of_live_discussions_created')
          .then((res) => (this.number_of_lds_created = Number(res.data)));
      },
      getNumberOfLiveDiscussionsRun(values) {
        adminServices
          .getSystemWideData(values, 'daily_number_of_live_discussions_run')
          .then((res) => (this.number_of_lds_run = Number(res.data)));
      },
      getNumberOfRoundtablesCreatedFromUniverse(values) {
        adminServices
          .getSystemWideData(
            values,
            'daily_number_of_roundtables_created_from_universe'
          )
          .then(
            (res) =>
              (this.number_of_rts_created_from_universe = Number(res.data))
          );
      },
      searchAnalytics(values) {
        this.filter_values = values;
        this.getNumberOfTeachersThatCreatedAtLeastOneCreated(values);
        this.getNumberActiveStudents(values);
        this.getNumberOfTeachersThatRanAtLeastOneCreated(values);
        this.getNumberOfRoundtablesCreated(values);
        this.getNumberOfRoundtablesRun(values);
        this.getNumberOfLiveDiscussionsCreated(values);
        this.getNumberOfLiveDiscussionsRun(values);
        this.getNumberOfRoundtablesCreatedFromUniverse(values);
      },
      closeModal() {
        this.show_roundtables_list = false;
        this.roundtables_to_show = [];
        this.page_number = 1;
        this.header_modal = '';
        this.show_more_roundtables = true;
      },
      showRoundtablesModal(type) {
        this.show_roundtables_list = true;
        this.showRoundtablesInfo(type);
      },
      showRoundtablesInfo(type) {
        this.filter_values.page_number = this.page_number;
        this.filter_values.page_size = this.page_size;
        this.list_roundtable_type = type;

        if (type === 'daily_list_of_roundtables_created') {
          this.header_modal = 'Written Roundtables Created';
        } else if (type === 'daily_list_of_roundtables_run') {
          this.header_modal = 'Written Roundtables Run';
        } else if (type === 'daily_list_of_live_discussions_created') {
          this.header_modal = 'Verbal Roundtables Created';
        } else {
          this.header_modal = 'Verbal Roundtables Run';
        }

        adminServices
          .getRoundtablesAnalytics(this.filter_values, type)
          .then((res) => {
            //&& this.roundtables_to_show.length < res.data.roundtables.total_roundtables
            if (res.data.roundtables && res.data.roundtables.length > 0) {
              this.roundtables_to_show.push(...res.data.roundtables);
              this.page_number += 1;
            } else {
              this.show_more_roundtables = false;
            }
          });
      },
      goToRoundtable(title, rt) {
        const { id, course_id, course_school_id } = rt;
        if (course_school_id) {
          courseDetailsService
            .createAdminSubscription(course_id, {
              school_id: course_school_id,
            })
            .then(() => {
              if (title.includes('Verbal')) {
                const url = `${URLconfigs.uiURL}/classes/${course_id}/roundtables/live/${id}`;
                window.open(url, '_blank');
              } else {
                const url = `${URLconfigs.uiURL}/classes/${course_id}/roundtables/online/${id}`;
                window.open(url, '_blank');
              }
            })
            .catch(() => {
              EventBus.$emit(
                'toast-msg',
                'Something went wrong...Please try again.'
              );
            });
        }
      },

      goToCourse(rt) {
        const { course_id, course_school_id } = rt;
        if (course_school_id) {
          courseDetailsService
            .createAdminSubscription(rt.course_id, {
              school_id: course_school_id,
            })
            .then(() => {
              const url = `${URLconfigs.uiURL}/classes/${course_id}?page=1`;
              window.open(url, '_blank');
            })
            .catch(() => {
              EventBus.$emit(
                'toast-msg',
                'Something went wrong...Please try again.'
              );
            });
        }
      },
      elementHasReachedScrollEnd(elementId) {
        const element = document.getElementById(elementId);

        return (
          element.scrollHeight - Math.floor(element.scrollTop) ===
            element.clientHeight ||
          element.scrollHeight - Math.round(element.scrollTop) ===
            element.clientHeight
        );
      },
      handleScroll() {
        if (
          this.elementHasReachedScrollEnd('admin-view-roundtables-table') &&
          this.show_more_roundtables
        ) {
          this.showRoundtablesInfo(this.list_roundtable_type, true);
        }
      },
    },
    mounted() {},
  };
</script>
<style lang="stylus" scoped>
  .admin-portal-analytics-container
    padding: 3.1rem 2rem 0 2rem
   .header-title
    font-weight: 600
    color: #273248
    font-size: 24px
  .sub-header
    font-weight: 400
    color: #595959
    font-size: 16px
  .linkable
    text-decoration: underline;
    cursor: pointer;
  .title
    margin: 0 0 20px 0
    span
      margin-right: 10px
      font-size: 18px
      font-weight: 600
  .scroll
    padding-right:10px
    overflow-y: auto
    height:calc(80vh - 185px)
  .row-style
    color: pl-primary
    min-height: 30px
    border-bottom: 1px solid #e8e8e8
</style>



// WEBPACK FOOTER //
// adminViewAnalytics.vue?1393dc4f